import React, { useEffect } from 'react';
import posthog from 'posthog-js';

import { ModeCard } from '../components/common/ModeCard';
import quickPlayIcon from '../assets/icons/quick-play-icon.svg';
import createLeagueIcon from '../assets/icons/create-league-icon.svg';

function Onboarding() {

    useEffect(() => {
        posthog.capture('onboarding_viewed');
    }, []);

    return (
        <div className="page-login onboarding-page">

            <div className="wrapper">

                <h1 className="mode-display-title">
                    WELCOME TO NOVA!
                </h1>

                <div className="mode-kicker">
                    Next steps
                </div>

                <div className="mode-cards">
                    <ModeCard
                        to="/play"
                        icon={quickPlayIcon}
                        title="QUICK PLAY"
                        description="Play live matches with a ready-made squad whenever you want."
                        highlighted
                    />
                    <ModeCard
                        to="/play-with-friends"
                        icon={createLeagueIcon}
                        title="CREATE LEAGUE"
                        description="Create your own league and invite others to play a classic season with matches, transfers and player development."
                    />
                </div>

            </div>

        </div>
    )
}

export {Onboarding}
